// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"image-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.5 17L9 10L2 21H22L16 13L13.5 17Z"}},{"tag":"circle","attrs":{"id":"fill2","cx":17,"cy":6,"r":3,"fill":"props.fillColor2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.5 17L9 10L2 21H22L16 13L13.5 17Z","strokeWidth":"props.strokeWidth"}},{"tag":"circle","attrs":{"id":"stroke2","cx":17,"cy":6,"r":3,"stroke":"props.strokeColor2","strokeWidth":"props.strokeWidth"}}]}]};

const Image1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image-1',
    ref,
    icon: element,
  },
));

Image1Icon.displayName = 'Image1Icon';

export default Image1Icon;
